
import { supabase } from '@/integrations/supabase/client';

/**
 * Generates a URL-friendly slug from a title
 */
export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Remove consecutive hyphens
    .trim();
};

/**
 * Checks if a slug already exists in the database
 * @returns true if slug exists, false otherwise
 */
export const checkSlugExists = async (slug: string, currentPostId?: string): Promise<boolean> => {
  try {
    let query = supabase
      .from('blog_posts')
      .select('id')
      .eq('slug', slug);
    
    // If we're editing an existing post, exclude it from the check
    if (currentPostId) {
      query = query.neq('id', currentPostId);
    }
    
    const { data, error } = await query.limit(1);
    
    if (error) {
      console.error('Error checking slug:', error);
      return false;
    }
    
    return data.length > 0;
  } catch (error) {
    console.error('Error checking slug:', error);
    return false;
  }
};

/**
 * Makes a slug unique by appending a number if necessary
 */
export const makeSlugUnique = async (baseSlug: string, currentPostId?: string): Promise<string> => {
  let slug = baseSlug;
  let counter = 1;
  let exists = await checkSlugExists(slug, currentPostId);
  
  while (exists) {
    slug = `${baseSlug}-${counter}`;
    counter++;
    exists = await checkSlugExists(slug, currentPostId);
  }
  
  return slug;
};
